import { useMutation } from "@tanstack/react-query";
import { generateReviewResponse } from "../../api/bReviewsApi";

export function useGenerateResponse() {
  return useMutation({
    mutationFn: (data) => generateReviewResponse(data),
  });
}
